import React from 'react';
import { Switch,Route } from 'react-router-dom'
import './App.css';
import MainLayout from './components/layout/main-layout';
import PageLayout from './components/layout/page-layout';
import  LoginContainer from "./components/containers/login-container";
import { Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from './helpers';
import { alertActions } from './actions';
import { PrivateRoute } from './helpers';
import { Notify } from 'react-redux-notify';
import 'react-redux-notify/dist/ReactReduxNotify.css';
import PatientContainer from "./components/containers/patient.container";
import MessageContainer from "./components/containers/message.container";
import ChangePassContainer from "./components/containers/changepass.container";
import CertRequestContainer from "./components/containers/certrequest.container";
import PatientCertRequestContainer from "./components/containers/patientcertrequest.container";
import CertPaymentContainer from "./components/containers/certpayment.container";
import ShowCertRequestContainer from "./components/containers/showcertrequest.container";
import ShowCertRequestSimpleContainer from "./components/containers/showcertrequestsimple.container";
import PatientListContainer from "./components/containers/patientlist.container";
import CertReqListContainer from "./components/containers/certreqlist.container";
import CertReqReportContainer from "./components/containers/certreqreport.container";
import DashboardContainer from "./components/containers/dashboard.container";
import MessageListContainer from "./components/containers/messagelist.container";
import PhysicianListContainer from "./components/containers/physicianlist.container";
import QuickCertRequestContainer from "./components/containers/quickcertrequest.container";
import ExcelReportContainer from "./components/containers/excelreport.container";
import moment from 'moment-jalaali';

const DashboardPage = props => {

  return ( 
    <MainLayout>
        <PageLayout >
            <DashboardContainer></DashboardContainer>  
        </PageLayout>
    </MainLayout> 
  );

};


const UserPage = props => {
    return (
      <MainLayout>
        <PageLayout title="User"></PageLayout>   
      </MainLayout> 
     
    );
  
};

const PatientPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <PatientContainer></PatientContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const QuickCertRequestPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <QuickCertRequestContainer></QuickCertRequestContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const MessagePage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <MessageContainer></MessageContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const ChangePassPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <ChangePassContainer></ChangePassContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};


const ExcelReportPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <ExcelReportContainer></ExcelReportContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};


const CertRequestPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <CertRequestContainer></CertRequestContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};
const PatientCertRequestPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <PatientCertRequestContainer></PatientCertRequestContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};
const CertPaymentPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <CertPaymentContainer></CertPaymentContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const ShowCertRequestPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <ShowCertRequestContainer></ShowCertRequestContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};
const ShowCertRequestSimplePage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <ShowCertRequestSimpleContainer></ShowCertRequestSimpleContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const PatientListPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <PatientListContainer></PatientListContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const PhysicianListPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <PhysicianListContainer></PhysicianListContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const InboxMessageListPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <MessageListContainer></MessageListContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};
const OutboxMessageListPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <MessageListContainer></MessageListContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const CertReqReportPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <CertReqReportContainer></CertReqReportContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};

const CertReqListPage = props => {
  return (
    <MainLayout>
      <PageLayout >
        <CertReqListContainer></CertReqListContainer>
      </PageLayout>   
    </MainLayout> 
   
  );

};
  
class App extends React.Component {

  
  constructor(props) {
      super(props);

      const { dispatch } = this.props;
      history.listen((location, action) => {
          // clear alert on location change
          dispatch(alertActions.clear());
      });
    //  moment.loadPersian({usePersianDigits: true,dialect: 'persian'})
    //  moment.defaultFormat ='DD-MM-YYYY HH:mm';

  }
 

  render() {
      const { alert } = this.props;
      return (
        <Router history={history}>
         <Notify position='BottomLeft' />
          <Switch>
            <PrivateRoute exact path="/dashboard"  component={DashboardPage} />
            <PrivateRoute exact path="/" component={DashboardPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/patient" component={PatientPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/quickcertrequest" component={QuickCertRequestPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/pp/:patientId"}  isEdit={true} component={PatientPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/certrequest/new/:patientId"}  isEdit={true} component={CertRequestPage} />
            
            <PrivateRoute roles={["Physician","Secretary"]} path={"/patientcertrequest/show/:patientId"}  isEdit={true} component={PatientCertRequestPage} />
            
            <PrivateRoute roles={["Physician","Secretary"]} path={"/certrequest/payment/:certreqId"}  isEdit={true} component={CertPaymentPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/showcertrequest/:certreqId"}  isEdit={true} component={ShowCertRequestPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/showcertrequestsimple/:certreqId"}  isEdit={true} component={ShowCertRequestSimplePage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/certrequestlist" component={CertReqListPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/pp/edit/:patientId"}  isEdit={true} component={PatientPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/patients" component={PatientListPage} />

            <PrivateRoute roles={["Physician","Secretary"]} path="/physicianlist"  component={PhysicianListPage} />

            <PrivateRoute roles={["Physician","Secretary"]} path="/message/inbox" inbox={true} component={InboxMessageListPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/message/outbox" inbox={false} component={OutboxMessageListPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/message/new" component={MessagePage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/changepass" component={ChangePassPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/excelreport" component={ExcelReportPage} />
            <PrivateRoute roles={["Physician","Secretary"]} path={"/message/show/:id"}   component={MessagePage} />
            <PrivateRoute roles={["Physician","Secretary"]} path="/certreqreport/:certreqId" component={CertReqReportPage} />
            <Route path="/login" component={LoginContainer} />
          </Switch>
        </Router>
      );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
      alert
  };
}

export default connect(mapStateToProps)(App);